import { createSelector } from 'reselect';
import { KEY } from '.';
import { GlobalState } from 'store/types';

const getDeliveryLogState = (state: GlobalState) => state[KEY];

const selectDeliveryLog = createSelector(getDeliveryLogState, (state) => state);

const selectExportData = createSelector(getDeliveryLogState, (state) => state.export.data);

const selectExportPending = createSelector(getDeliveryLogState, (state) => state.export.pending);

const selectPriceTypes = createSelector(getDeliveryLogState, (state) => state.priceTypes);

const selectPriceTypesPending = createSelector(getDeliveryLogState, (state) => state.priceTypesPending);

const selectSettlementReport = createSelector(getDeliveryLogState, (state) => state.settlementReport);

const selectSalesReport = createSelector(getDeliveryLogState, (state) => state.salesReport);

const selectSalesByCardTypeReport = createSelector(getDeliveryLogState, (state) => state.salesByCardTypeReport);

export const selectors = {
  selectDeliveryLog,
  selectExportData,
  selectExportPending,
  selectPriceTypes,
  selectPriceTypesPending,
  selectSettlementReport,
  selectSalesReport,
  selectSalesByCardTypeReport
};
